<app-sidenav>
  @if (displaySideCard) {
    <ng-template #sidenavContent>
      <app-card class="card" [title]="'content.admin-title' | translate">
        <nav [attr.aria-label]="'content.admin-areas' | translate">
          <ul class="nav accent nav-pills flex-column">
            <li class="nav-item">
              <a class="nav-link"
                routerLink="/admin/users"
              [ngClass]="{active: isActive('/admin/users')}">{{ 'content.users' | translate }}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link"
                routerLink="/admin/companies"
              [ngClass]="{active: isActive('/admin/companies')}">{{ 'content.companies' | translate }}</a>
            </li>
          </ul>
        </nav>
      </app-card>
    </ng-template>
  }
  <ng-template #mainContent>
    <!-- Don't put an h1 main title here.  The components define their own -->
    <router-outlet></router-outlet>
  </ng-template>
</app-sidenav>
